import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import KaraokePlayer from "@/pages/KaraokePlayer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [lyricsData, setLyricsData] = useState(null);

  return (
    <div className="App min-h-screen bg-[var(--bg-default)]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage onLyricsReady={setLyricsData} />} />
          <Route path="/karaoke" element={<KaraokePlayer lyricsData={lyricsData} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
